import "./App.css";
import Header from "./components/Header";
import NewTask from "./components/NewTask";
import Footer from "./components/footer";
function App() {
  return (
    <>
      <Header />
      <NewTask />
      <Footer />
    </>
  );
}

export default App;
